import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export default class Scroll {
    constructor() {
        this.init()
    }

    init() {
        this.fadeWave()
        this.onScroll()
    }

    fadeWave() {
        const revealElm = document.querySelector('.js-wave')
        const triggerElm = document.querySelector('.js-bgtrigger')

        gsap.to(revealElm, {
            opacity: 0.2,
            scrollTrigger: {
                trigger: triggerElm,
                start: 'top top',
                //markers: true,
                scrub: true,
                autoKill: false,
                onLeave: () => document.body.classList.add('-hidetop'),
            },
        })
    }

    onScroll() {
        const funcElm = [...document.querySelectorAll('.js-scrollfunc')]

        funcElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 85%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-scrollfunc')
                },
            })
        })

        const windmillElm = [...document.querySelectorAll('.js-scrollreveal')]

        windmillElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 75%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-reveal')
                },
            })
        })
    }
}
